<template>
  <div class="map-tabs map-tabs__gallery">
    <div
      v-show="!getIsMobile"
      class="map-tabs__list container-fluid">
      <div v-for="(location, index) in locations"
           class="map-tabs__item"
           :class="{active: get_selected_location.location_city === location.location_city}"
           role="button"
           :aria-label="location.location_city"
           @click="changeLocation(location)"
           :key="`location-${uid}-${index}`">
        {{ location.location_city }}
      </div>
    </div>
    <div
      class="position-relative map-tabs__map-block map-tabs__gallery-block"
      v-if="get_selected_location"
      :key="`office-gallery-map-${selected_location_key_i}`">
      <div class="map-tabs__gallery-block_row">
        <div class="map-tabs__gallery-block_gallery">
            <full-width-image-carousel
              class="map-tabs__gallery-block_gallery-carousel"
              :img_border_radius="false"
              nav_buttons_inside_block
              lazy_carousel
              :images="get_selected_location.tab_images"
            />
        </div>
        <div class="map-tabs__gallery-block_desc">
          <div class="map-tabs__gallery-block_desc-title">
            <location-icon/>
            {{get_selected_location.location_city}}
          </div>
          <html-block
            class="map-tabs__gallery-block_desc-text"
            :content="get_selected_location.location_description || ''"
          />
          <template v-if="get_counters.length">
            <counter-text
              v-for="(counter, index) in get_counters"
              class="mt-30 mt-xs-20 map-tabs__gallery-block_desc__counter"
              :title="counter.text"
              :add_plus_symbol="counter.add_plus_symbol"
              :count_to="counter.count_to"
              :key="`counter_text-${selected_location_key_i}-${index}`"
            />
          </template>
          <span
            @click="changeLocationDirection(true)"
            class="map-tabs__gallery-block_desc-arrow prev">
            <chevron-left-icon/>
          </span>
          <span
            @click="changeLocationDirection()"
            class="map-tabs__gallery-block_desc-arrow">
             <chevron-right-icon />
          </span>
        </div>
        <div class="map-tabs__gallery-block_map">
          <office-map
            :frame_src="get_selected_location.frame_src"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OfficeMap from "../parts/OfficeMap.vue";
import SearchIcon from "../icons/SearchIcon.vue";
import HtmlBlock from "../small_parts/HtmlBlock.vue";
import LocationIcon from "../icons/LocationIcon.vue";
import FullWidthImageCarousel from "../parts/FullWidthImageCarousel.vue";
import uid_mixin from "../../mixins/uid_mixin";
import {mapGetters} from "vuex";
import ArrowRightIcon from "../icons/ArrowRightIcon.vue";
import SwiperSlideArrows from "../small_parts/SwiperSlideArrows.vue";
import ChevronLeftIcon from "../icons/ChevronLeftIcon.vue";
import ChevronRightIcon from "../icons/ChevronRightIcon.vue";
import CounterText from "../small_parts/CounterText.vue";

export default {
  name: "MapTabsGallery",
  mixins: [uid_mixin],
  components: {
    CounterText,
    ChevronRightIcon, ChevronLeftIcon,
    SwiperSlideArrows,
    ArrowRightIcon,
    FullWidthImageCarousel,
    LocationIcon,
    HtmlBlock,
    SearchIcon,
    OfficeMap
  },
  props: {
    /**props**/
    locations: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        frame_src: {
          type: String,
          required: true,
          default: '',
          admin_type: 'textarea',
        },
        location_city: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        location_description: {
          type: String,
          default: '',
          admin_type: 'editor',
        },
        tab_images: {
          type: Array,
          default: () => [],
          admin_type: 'array',
          array_values: {
            image_src: {
              type: String,
              required: true,
              admin_type: 'image',
            },
            image_lazy_src: {
              type: String,
              default: '',
              admin_type: 'image',
            },
          },
        },
        tab_counters: {
          type: Array,
          default: () => [],
          admin_type: 'array',
          array_values: {
            count_to: {
              type: String,
              default: '',
              admin_type: 'input',
            },
            text: {
              type: String,
              default: '',
              admin_type: 'textarea',
            },
            add_plus_symbol: {
              type: Boolean,
              default: false,
              admin_type: 'checkbox',
            },
          },
        },
      },
    },
    /**props**/
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    uid() {
      return this._uid
    },
    get_selected_location() {
      return this.selected_location
        ? this.selected_location
        : this.locations.length
          ? this.locations[0]
          : null
    },
    get_counters() {
      return (this.get_selected_location?.tab_counters || []).filter(el => {
        return el.count_to && el.text
      })
    },
  },
  data() {
    return {
      selected_location: null,
      selected_location_key_i: 0,
    }
  },
  methods: {
    changeLocation(location) {
      if (this.get_selected_location.location_city === location.location_city) return
      this.selected_location = location
      this.selected_location_key_i++
    },
    changeLocationDirection(prev = false) {
      let selected_index = this.locations.findIndex(el => el.location_city === this.get_selected_location.location_city)
      if (selected_index < 0) {
        this.changeLocation(this.get_selected_location)
        return
      }
      selected_index = prev ? selected_index -1 : selected_index + 1
      let new_location = this.locations[selected_index] || null
      if (new_location) {
        this.changeLocation(new_location)
        return
      }
      selected_index = selected_index < 0
        ? this.locations.length - 1
        : this.locations.length >= selected_index
          ? 0
          : this.locations.length - 1

      this.changeLocation(this.locations[selected_index] || this.get_selected_location)
    },
  }
}
</script>
